import { getVariantStock, resolveVariants } from '../config'
import './ProductVariantSizeChips.css'

/**
 * @param {{
 *   product: object,
 *   selectedId: string,
 *   onSelectId: (id: string) => void,
 *   inventory?: object,   // live inventory map keyed by "productId__variantId"
 *   productId?: string,   // needed to look up per-variant preorder from inventory
 * }} props
 */
export default function ProductVariantSizeChips({ product, selectedId, onSelectId, inventory, productId }) {
  const variants = resolveVariants(product)
  if (!variants.length) return null

  return (
    <div className="pvs">
      <p className="pvs__label">Size</p>
      <div className="pvs__row">
        {variants.map((v) => {
          const active = v.id === selectedId

          // Per-variant preorder check from live inventory
          const invKey     = productId ? `${productId}__${v.id}` : null
          const invEntry   = invKey ? inventory?.[invKey] : null
          const vPreorder  = !!(invEntry?.preorder)

          // Stock-based states — suppressed entirely when this variant is pre-order
          const s      = getVariantStock(product, v, inventory)
          const vOut   = !vPreorder && s === 'out_of_stock'
          const vSoon  = !vPreorder && s === 'coming_soon'
          const vLow   = !vPreorder && s === 'low_stock'

          const chipClass = [
            'pvs__chip',
            active && 'pvs__chip--active',
            vOut && 'pvs__chip--oos',
            vSoon && 'pvs__chip--soon',
            vPreorder && 'pvs__chip--preorder',
          ].filter(Boolean).join(' ')

          return (
            <button key={v.id} type="button" className={chipClass} onClick={() => onSelectId(v.id)}>
              <span className="pvs__chip-label">{v.label}</span>

              {vPreorder && <span className="pvs__chip-sub">Pre-order</span>}
              {vOut && <span className="pvs__chip-sub">Sold out</span>}
              {vSoon && <span className="pvs__chip-sub">Coming soon</span>}
              {vLow && !active && <span className="pvs__chip-sub pvs__chip-sub--low">Low stock</span>}
            </button>
          )
        })}
      </div>
    </div>
  )
}
